import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VideosByTagComponent } from './pages/videos-by-tag/videos-by-tag.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { loginGuard } from './login.guard';
import { LoginComponent } from './pages/login/login.component';
import { UserVideosComponent } from './pages/user-videos/user-videos.component';
import { SearchPageComponent } from './pages/search-page/search-page.component';
import { ChannelVideosComponent } from './pages/channel-videos/channel-videos.component';


const routes: Routes = [
  {
    path: "videos-by-tag",
    component: VideosByTagComponent,
    canActivate: [loginGuard]
  },
  {
    path: "search",
    component: SearchPageComponent,
    canActivate: [loginGuard]
  },
  {
    path: "video",
    loadChildren: ()=> import('./modules/watch-video/watch-video.module').then(d => d.WatchVideoModule),
    canActivate: [loginGuard]
  },
  {
    path: "favorites",
    component: UserVideosComponent,
    canActivate: [loginGuard]
  },
  {
    path: "history",
    component: UserVideosComponent,
    canActivate: [loginGuard]
  },
  {
    path: "my-videos",
    component: UserVideosComponent,
    canActivate: [loginGuard]
  }
  ,
  {
    path: "signin",
    component: LoginComponent
  },
  {
    path: "channel",
    component: ChannelVideosComponent,
    canActivate: [loginGuard]

  }
  , {
    path: "last-videos",
    component: HomePageComponent,
    canActivate: [loginGuard]

  },
  {
    path: "",
    pathMatch: 'full',
    redirectTo: 'last-videos',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
